// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3j8OT","right":"styles_right__2_mlF"};